module.exports = __webpack_public_path__ + "img/5.6ae39f7e.png";